import React, { Component, PropTypes } from "react";
import { observer, inject } from "mobx-react";
import DataTable from "../DataTable";
import Spinner from "../Spinner";
import Form, { FormBody, SelectInput, TextInput } from "../Form";
import ReactDropzone from "react-dropzone";
import { observable } from "mobx";
import { station } from "../../actions/api";
import { post } from "../../actions/apiMethods";
import moment from "moment";

@inject("stationStore")
@observer
class DaqManualImport extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
  };

  componentWillMount() {
    const { stationStore } = this.props;
    if (!stationStore.items.length && !stationStore.isLoading) stationStore.fetchItems();
  }

  slug = "daq/manual-import";

  @observable file = null;
  @observable columns = [];
  @observable data = [];

  @observable selectedStations = [];
  @observable selectedStationDataOriginCode = [];
  @observable parameterCodeOptions = [];
  @observable selectedParameterCodes = [];
  @observable dateFormat = 'YYYY-MM-DD HH:mm:ss'

  onChangeSelectInput = async (value, index) => {
    this.selectedStations[index] = value;

    const dataOrigins = await station.fetchDataOrigins(value);

    if (!dataOrigins || !dataOrigins[0] || !dataOrigins[0].data_origin_parameters) {
      this.selectedStationDataOriginCode[index] = null;
      this.parameterCodeOptions[index] = [];
    } else {
      this.selectedStationDataOriginCode[index] = dataOrigins[0].code;
      this.parameterCodeOptions[index] =
        dataOrigins.flatMap(origin => origin.data_origin_parameters.map((dataorigin) => ({
          label: dataorigin.parameter_name,
          value: dataorigin.code,
        })));
    }

    this.data[0][this.columns[index + 1].key] = (
      <Form>
        <FormBody>
          <SelectInput
            id={`station-${index + 1}`}
            label=""
            options={this.props.stationStore.items}
            fields={{ label: "name", value: "id" }}
            value={value}
            onChange={(e) => this.onChangeSelectInput(e.target.value, index)}
            small
          />
          <SelectInput
            id={`parameter-code-${index + 1}`}
            label=""
            options={this.parameterCodeOptions[index]}
            fields={{ label: "label", value: "value" }}
            value={this.selectedParameterCodes[index]}
            onChange={(e) => this.onChangeDataOrigin(e.target.value, index)}
            small
          />
        </FormBody>
      </Form>
    );
  };

  onChangeDataOrigin = (value, index) => {
    this.selectedParameterCodes[index] = value;
    this.data[0][this.columns[index + 1].key] = (
      <Form>
        <FormBody>
          <SelectInput
            id={`station-${index + 1}`}
            label=""
            options={this.props.stationStore.items}
            fields={{ label: "name", value: "id" }}
            value={this.selectedStations[index]}
            onChange={(e) => this.onChangeSelectInput(e.target.value, index)}
            small
          />
          <SelectInput
            id={`parameter-code-${index + 1}`}
            label=""
            options={this.parameterCodeOptions[index]}
            fields={{ label: "label", value: "value" }}
            value={value}
            onChange={(e) => this.onChangeDataOrigin(e.target.value, index)}
            small
          />
        </FormBody>
      </Form>
    );
  };

  onChangeDateFormat = (e) => this.dateFormat = e.target.value;

  onDrop = (files) => {
    const { notify } = this.context;
    if (!files[0]) return;
    if (!files[0].name.toLowerCase().endsWith(".csv")) {
      notify.error({ message: "Upload csv file" });
      return;
    }
    this.file = files[0];
    let reader = new FileReader();
    reader.readAsText(files[0]);
    reader.onload = () => {
      try {
        const lines = reader.result.split("\n");
        const headers = lines[0].split(",");

        const result = [];
        this.columns = headers.map((header) => ({
          key: header,
          label: header,
        }));

        for (let i = 1; i < lines.length; i++) {
          if (!lines[i]) continue;
          const obj = {};
          const currentline = lines[i].split(",");

          for (let j = 0; j < headers.length; j++) {
            obj[headers[j]] = currentline[j];
          }
          result.push(obj);
        }

        const finalObject = {};

        this.selectedStations = [];
        this.selectedStationDataOriginCode = [];
        this.parameterCodeOptions = [];
        this.selectedParameterCodes = [];

        for (let i = 1; i < headers.length; i++) {
          this.selectedStations.push(null);
          this.selectedStationDataOriginCode.push(null);
          this.parameterCodeOptions.push([]);
          this.selectedParameterCodes.push(null);
          const element = headers[i];
          finalObject[element] = (
            <Form>
              <FormBody>
                <SelectInput
                  id={`station-${i}`}
                  label=""
                  options={this.props.stationStore.items}
                  fields={{ label: "name", value: "id" }}
                  value={""}
                  onChange={(e) => this.onChangeSelectInput(e.target.value, i - 1)}
                  small
                />
              </FormBody>
            </Form>
          );
        }
        result.unshift(finalObject);
        this.data = result;
      } catch (e) {
        console.log(e);
        notify.error({ message: "Error parsing data" });
      }
    };
  };

  onSubmit = async () => {
    const { notify } = this.context;
    const data = this.data.slice(1);
    const payload = [];

    for (const info of data) {
      const keys = Object.keys(info);
      const firstKey = keys[0];

      keys.slice(1).forEach((key, index) => {
        if (
          !this.selectedStationDataOriginCode[index] ||
          !this.selectedParameterCodes[index] ||
          !info[key] ||
          !info[firstKey] ||
          info[key] === "-9999"
        )
          return;
        payload.push({
          origin_code: this.selectedStationDataOriginCode[index],
          parameter_code: this.selectedParameterCodes[index],
          value: info[key],
          time: moment(info[firstKey], this.dateFormat).format('YYYY-MM-DD HH:mm:ss')
        });
      });
    }
    try {
      const res = await post("import", payload);
      if (res && (res.message || (res[0] && res[0].requestId))) {
        notify.success({ message: "Data posted" });
      } else {
        notify.error({ message: "Error posting data" });
      }
    } catch (error) {
      notify.error({ message: "Error submitting data" });
    }
  };

  render() {
    const { stationStore } = this.props;
    if (stationStore.isLoading) return <Spinner />;

    return (
      <div>
        <ReactDropzone
          ref="dropzone"
          onDrop={this.onDrop}
          style={{ display: "inline-block", width: "100%", height: "100%" }}
        >
          <button className="button">
            {this.file ? "Edit file" : "Add file"}
          </button>
        </ReactDropzone>
        {this.file && <p>{this.file.name}</p>}

        {this.file && <Form>
          <FormBody>
            <TextInput label={<div>
              Date Format
              <a href='https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/' target='_blank' rel="noopener noreferrer"><i className='fa fa-question-circle' style={{ color: '#3c8dbc', fontSize: '14px' }} /></a>
            </div>} value={this.dateFormat} onChange={this.onChangeDateFormat} />
          </FormBody>
        </Form>
        }

        {this.data.length > 0 && (
          <div>
            <DataTable
              data={this.data}
              slug={this.slug}
              columns={this.columns}
            />
            <button className="button" onClick={this.onSubmit}>
              Submit
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default DaqManualImport;



// WEBPACK FOOTER //
// ./src/components/DataSource/DaqManualImport.js